import { saveAs } from 'file-saver';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';

const baseUrl = 'kubernetes';

// the server builds this filename from unsanitized, user-editable values (username,
// environment name), so it's sanitized here rather than trusted as-is
function sanitizeFilename(filename: string) {
  return filename.replace(/[^a-zA-Z0-9._-]/g, '_');
}

export async function saveFullAccessKubeconfigFile(
  environmentIds: EnvironmentId[]
) {
  try {
    const { headers, data } = await axios.get<Blob>(`${baseUrl}/config`, {
      params: { ids: JSON.stringify(environmentIds) },
      responseType: 'blob',
      headers: {
        Accept: 'text/yaml',
      },
    });
    const contentDispositionHeader = headers['content-disposition'];
    const filename = contentDispositionHeader.replace('attachment;', '').trim();
    saveAs(data, sanitizeFilename(filename));
  } catch (e) {
    throw parseAxiosError(e as Error, '');
  }
}

export function saveScopedKubeconfigFile(
  kubeconfig: string,
  environmentName: string
) {
  saveAs(
    new Blob([kubeconfig], { type: 'text/yaml' }),
    sanitizeFilename(`kubeconfig-${environmentName}-scoped.yaml`)
  );
}
